import { PDFViewerVariantType, } from '../../../../../components/pdfViewer/types/pdfViewerTheme';
import { Z_INDEX } from '../../foundations/zIndex';
import { IconButtonSizeType, IconButtonVariantType } from '../variants';
export const getPDFViewerStyles = (FOUNDATIONS, SHADOWS) => {
    return {
        [PDFViewerVariantType.DEFAULT]: {
            parentContainer: {
                position: 'relative',
                background_color: 'transparent',
                box_shadow: SHADOWS.shadow_50,
            },
            pagesContainer: {
                height: 'auto',
                min_height: '100vh',
                overflow: 'hidden',
                display: 'flex',
                flex_direction: 'column',
                align_items: 'center',
            },
            pageContainer: {
                position: 'relative',
            },
            canvasContainer: {
                position: 'relative',
                width: '100%',
                overflow: 'hidden',
            },
            pageContentContainer: {
                position: 'absolute',
                overflow: 'clip',
                opacity: '1',
                z_index: 0,
            },
            pageContent: {
                position: 'absolute',
                white_space: 'pre',
            },
            iconButtonContainer: {
                position: 'absolute',
                bottom: FOUNDATIONS.spacing_300,
                left: '50%',
                transform: 'translateX(-50%)',
                cursor: 'pointer',
                z_index: Z_INDEX.INTERN_3,
            },
            iconButton: {
                variant: IconButtonVariantType.SECONDARY_FILLED,
                size: IconButtonSizeType.MEDIUM,
            },
        },
    };
};
//# sourceMappingURL=styles.js.map